import React, {useState, useEffect, useCallback} from 'react';

import {Block} from '../../components/uiElem';
import Idenfy from '../KYC/Idenfy';
import {patchPayload} from '../../lib/misc';

function Step2(props) {
  const {patchHandler, status, data, ...restProps} = props;
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [iframeMethodType, setIframeMethodType] = useState('');
  const kycPartner = data.credit_request_session?.kyc_partner[0]; // s, t or i

  const submitIframe = useCallback(() => {
    patchHandler(patchPayload(iframeMethodType, status));
  }, [patchHandler, iframeMethodType, status]);

  useEffect(() => {
    if (btnDisabled === false) {
      submitIframe();
    }
  }, [btnDisabled, submitIframe]);

  return (
    <div className="w-full pb-10">
      <Block>
        <div className="relative">
          {(kycPartner === 'i' || !kycPartner) && (
            <Idenfy
              {...restProps}
              data={data}
              status={status}
              setBtnDisabled={setBtnDisabled}
              setIframeMethodType={setIframeMethodType}
            />
          )}
        </div>
      </Block>
    </div>
  );
}

export default Step2;
